module.exports = __webpack_public_path__ + "static/media/close.bab252bb.svg";